var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.414 15.8897L16.556 5.74773L15.142 4.33373L5 14.4757V15.8897H6.414ZM7.243 17.8897H3V13.6467L14.435 2.21173C14.6225 2.02426 14.8768 1.91895 15.142 1.91895C15.4072 1.91895 15.6615 2.02426 15.849 2.21173L18.678 5.04073C18.8655 5.22826 18.9708 5.48257 18.9708 5.74773C18.9708 6.0129 18.8655 6.2672 18.678 6.45473L7.243 17.8897ZM3 19.8897H21V21.8897H3V19.8897Z",
    fill: "#213867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.916a7cdde075637e7f67392a445d7dc5.svg";
export { ForwardRef as ReactComponent };